import { Component } from '@angular/core';
import { PdvService } from '@app/services/pdv/pdv.service';

@Component({
    selector: 'mobile',
    templateUrl: 'mobile.component.html',
    styleUrls: ['mobile.component.scss']
})
export class MobileComponent {
    ios:"";
    android:"";
    constructor(private pdvService: PdvService) {
        this.pdvService.pdv.subscribe(
            (pdv) => {
                if (pdv) {
                    this.ios = pdv.ios;
                    this.android = pdv.android;
                }
            }
        )
    }
}
